module.exports = __webpack_public_path__ + "static/product-detail-shipping-20230522-16ca044a50165233f0fc1daa40f8e45e.jpeg";